import { render, staticRenderFns } from "./DynamicDetails.vue?vue&type=template&id=73033d16&scoped=true"
import script from "./DynamicDetails.vue?vue&type=script&lang=js"
export * from "./DynamicDetails.vue?vue&type=script&lang=js"
import style0 from "./DynamicDetails.vue?vue&type=style&index=0&id=73033d16&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73033d16",
  null
  
)

export default component.exports